import {get} from '../utils/http';
import Order from '../models/Order';
import Trip from '../models/Trip';


// doc: https://doc.oschina.net/xingchengzushou?t=218986
export function getOneByTripId(trip_id) {
  let url = '/m/v2/?m=api/order/get_trip_rel_info';

  return get(url, {
    data: {trip_id}
  })
    .then(function (data) {
      let order = data.order_info;

      if (!order) {
        order = data.recommend_rent_car_info.info;
      }

      order = Order.parseInput(order);
      return order;
    });
}

// 获取行程poi点列表
export function getRecommendTripPoi(params) {
  let url = '/m/v2/?m=api/order/get_trip_poi_info';

  return get(url, { 
    data: params
  })
    .then(function (data) {
      return data;
    });
}

// doc: https://doc.oschina.net/xingchengzushou?t=218314
export function getAll(show_discover_trip = 1) {
  let url = '/m/v2/?m=api/order/card_list_v2';

  return get(url, {
    data: {show_discover_trip}
  })
  // 数据转换
    .then(async function (data) {
      let orders = [], trips = [];

      orders = data.order_list.map(function (order) {
        return Order.parseInput(order);
      });

      // 之前是一次性返回所有推荐行程的，有问题，现在循环遍历orderList请求相应推荐订单push到trip里
      for (let i = 0; i < data.order_list.length; i++) {
        const { order_cards } = await getRecommendTripPoi({
          'city': data.order_list[i].city,
          'dropoff_city': data.order_list[i].dropoff_city,
          'from_time': data.order_list[i].from_time,
          'to_time': data.order_list[i].to_time,
          'order_id': data.order_list[i].order_id
        });
        // 如果推荐行程不为空
        if (order_cards.discover_list && Object.keys(order_cards.discover_list).length) {
          for (let tripItem in order_cards.discover_list) {
            order_cards.discover_list[tripItem].days = order_cards.discover_list[tripItem].tags[0].tag_name;
            order_cards.discover_list[tripItem].poi_list = order_cards.discover_list[tripItem].poilist;
            trips.push(Trip.parseInput2(order_cards.discover_list[tripItem]));
            // 将行程id插入discover_trip.ids中
            orders.map(item => {
              if (item.order_id === data.order_list[i].order_id) {
                item.discover_trip.ids.push(order_cards.discover_list[tripItem].trip_id);
              }
            });
          }
        }
      }

      let result = {orders, trips};
      return result;
    });
}



// WEBPACK FOOTER //
// ./src/services/order.js